import { InsuranceCompanyCode } from '../../../models/insurance-company-code.enum';
import { AdditionalInformationModeConfig, VisibilityRequirement } from './additional-information-mode.config';
import { AdditionalInformationSectionConsts } from './additional-information-section.consts';
import {VehicleQuestionAnswer} from '../../../../core/consts/vehicle-question-answer.enum';

export class AdditionalInformationSectionModeConfig {

  private readonly DEFAULT_CONFIG_KEY = 'DEFAULT';
  private companyCode: InsuranceCompanyCode;

  private config: { [key: string]: AdditionalInformationModeConfig } = {
    /**
     * default CONFIG
     */
    [this.DEFAULT_CONFIG_KEY]: {
      [AdditionalInformationSectionConsts.VIN]: {
        visible: true
      }
    },
    /**
     * GENERALI CONFIG
     */
    [InsuranceCompanyCode.GENERALI]: {
      [AdditionalInformationSectionConsts.VIN]: {
        visible: true
      },
      [AdditionalInformationSectionConsts.KEYS_AMOUNT]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.IMMOBILIZER]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.MECHANIC_LOCK_TRANSMISSION]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.AUTOALARM]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.GPS]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      }
    },
    /**
     * PROAMA CONFIG
     */
    [InsuranceCompanyCode.PROAMA]: {
      [AdditionalInformationSectionConsts.VIN]: {
        visible: true
      },
      [AdditionalInformationSectionConsts.KEYS_AMOUNT]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.IMMOBILIZER]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.MECHANIC_LOCK_TRANSMISSION]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.AUTOALARM]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.GPS]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      }
    },
    /**
     * UNIQA CONFIG
     */
    [InsuranceCompanyCode.UNIQA]: {
      [AdditionalInformationSectionConsts.VIN]: {
        visible: true
      },
      [AdditionalInformationSectionConsts.USA_CANADA_REGISTRATION]: {
        visible: true,
        defaultValue: VehicleQuestionAnswer.USA_CANADA_REGISTRATION_NO
      }
    },
    /**
     * TUZ CONFIG
     */
    [InsuranceCompanyCode.TUZ]: {
      [AdditionalInformationSectionConsts.VIN]: {
        visible: true
      },
      [AdditionalInformationSectionConsts.TECHNICAL_INSPECTION_DATE]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.ORIGINAL_KEYS_AMOUNT]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.LEECHED_KEYS_AMOUNT]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.IMMOBILIZER]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.MECHANIC_LOCK_TRANSMISSION]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.AUTOALARM]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.GPS]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
      [AdditionalInformationSectionConsts.OTHER_SECURITIES]: {
        visible: true,
        visibilityRequirements: [ VisibilityRequirement.HAS_AC_OR_AC_MINI ]
      },
    },
    /**
     * ALLIANZ CONFIG
     */
    [InsuranceCompanyCode.ALLIANZ]: {
      [AdditionalInformationSectionConsts.VIN]: {
        visible: true
      },
      [AdditionalInformationSectionConsts.ORIGINAL_KEYS_AMOUNT]: {
        visible: true,
      },
      [AdditionalInformationSectionConsts.LEECHED_KEYS_AMOUNT]: {
        visible: true,
      }
    }
  };

  constructor(code: InsuranceCompanyCode) {
    this.companyCode = code;
  }

  getConfig(): AdditionalInformationModeConfig {
    return this.config[this.companyCode] ? this.config[this.companyCode] : this.config[this.DEFAULT_CONFIG_KEY];
  }

}
